<main class="flex w-full flex-auto flex-col">
    <div class="flex w-full flex-col">
        <div class="flex w-full flex-wrap gap-4 p-6 md:p-8">
            <div class="flex w-full items-center">
                <!-- SEARCH (INTACTO) -->
                <mat-form-field class="fuse-mat-no-subscript fuse-mat-dense w-full sm:w-80" [appearance]="'outline'">
                    <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                    <input matInput [placeholder]="'Buscar categoria...'" (input)="onSearch($event.target.value)"
                        [autocomplete]="'off'" />
                </mat-form-field>

                <!-- BOTÃO (INTACTO, só alinhado à direita) -->
                <div class="ml-6 ml-auto flex items-center" *ngIf="!permissionService.can('create_category')">
                    <button class="hidden sm:flex gap-2 bg-orange-600 rounded-md text-white" mat-flat-button [style.background-color]="'#eb670f'"
                        (click)="newCategory()">
                        <mat-icon class="icon-size-5" style="color: white !important; fill: white !important;"
                            [svgIcon]="'heroicons_solid:plus'"></mat-icon>
                        <span class="ml-2 text-white">Nova Categoria</span>
                    </button>

                    <!-- Actions menu (visible on xs) -->
                    <div class="sm:hidden">
                        <button [matMenuTriggerFor]="actionsMenu" mat-icon-button>
                            <mat-icon [svgIcon]="'heroicons_mini:ellipsis-vertical'">
                            </mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu">
                            <button (click)="newCategory()" mat-menu-item>
                                Nova Categoria
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>

            <section class="grid w-full grid-cols-3 gap-4 lg:grid-cols-3">
                <category-cards title="Total de Categorias" [value]="totalAmount ?? 0" color=""
                    icon=""></category-cards>

                <category-cards title="Total de Subcategorias" [value]="analyticalMetrics?.totalSubcategories ?? 0"
                    color="" icon=""></category-cards>

                <category-cards title="Anúncios Ativos" [value]="analyticalMetrics?.totalActiveAds ?? 0" color=""
                    icon=""></category-cards>
            </section>
        </div>
    </div>

    <fuse-card class="mat-elevation-z8 mx-8 my-5 block">
        <div class="overflow-y-auto">
            <table mat-table cdkDropList [dataSource]="dataSource" (cdkDropListDropped)="drop($event)" matSort (matSortChange)="onSortChange($event)">
                <!-- Priority Order -->
                <ng-container matColumnDef="priority_order">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-4 w-24">
                        Ordem
                    </th>
                    <td mat-cell *matCellDef="let row" class="px-4 text-center">
                        <span class="inline-flex items-center justify-center rounded-md bg-orange-100 px-2 py-1 text-xs font-bold text-orange-700">
                            {{ row.priority_order ?? 0 }}
                        </span>
                    </td>
                </ng-container>

                <!-- Icon -->
                <ng-container matColumnDef="icon">
                    <th mat-header-cell *matHeaderCellDef class="px-4 text-left">
                        Categoria
                    </th>
                    <td mat-cell *matCellDef="let row" class="px-4">
                        <div class="flex items-center gap-3">
                            <div class="flex flex-shrink-0 items-center justify-center">
                                <ng-icon [name]="row.icon" *ngIf="row.icon?.includes('ph')"
                                    class="text-muted-foreground text-xl"></ng-icon>
                                <mat-icon *ngIf="!row.icon?.includes('ph')" class="text-muted-foreground">
                                    {{ row.icon?.replace('heroicons_outline:', '')?.replace('feather:', '') }}
                                </mat-icon>
                            </div>

                            <span class="text-foreground whitespace-nowrap font-medium">
                                {{ row.name }}<br />
                                {{ row.subcategory?.length ?? 0 }} subcategorias
                            </span>
                        </div>
                    </td>
                </ng-container>

                <!-- Name -->
                <ng-container matColumnDef="subcategory">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Subcategorias
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="font-medium">
                            {{ row.subcategory?.join(', ') }}
                        </span>
                    </td>
                </ng-container>

                <!-- Active Ads Count -->
                <ng-container matColumnDef="activeAdsCount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Anúncios
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.activeAdsCount }}
                    </td>
                </ng-container>

                <!-- Conversion Rate -->
                <ng-container matColumnDef="conversionRate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Conversão
                    </th>

                    <td mat-cell *matCellDef="let row">
                        <span class="flex items-center justify-center gap-1">
                            {{ row.conversionRate / 100 | percent: '1.1-2' }}

                            <ng-container [ngSwitch]="row.trend">
                                <!-- UP -->
                                <mat-icon *ngSwitchCase="'UP'" class="text-base text-green-600">
                                    trending_up
                                </mat-icon>

                                <!-- DOWN -->
                                <mat-icon *ngSwitchCase="'DOWN'" class="text-base text-red-600">
                                    trending_down
                                </mat-icon>

                                <!-- SAME -->
                                <mat-icon *ngSwitchCase="'SAME'" class="text-base text-gray-400">
                                    trending_flat
                                </mat-icon>
                            </ng-container>
                        </span>
                    </td>
                </ng-container>

                <!-- Trend -->
                <!-- <ng-container matColumnDef="trend">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header

                    >
                        Tendência
                    </th>
                    <td mat-cell *matCellDef="let row" >
                        <mat-icon
                            [ngClass]="{
                                'text-green-500': row.trend === 'UP',
                                'text-red-500': row.trend === 'DOWN',
                                'text-blue-500': row.trend === 'STABLE',
                            }"
                            [matTooltip]="
                                row.trend === 'UP'
                                    ? 'Em alta'
                                    : row.trend === 'DOWN'
                                      ? 'Em baixa'
                                      : 'Estável'
                            "
                        >
                            {{
                                row.trend === 'UP'
                                    ? 'trending_up'
                                    : row.trend === 'DOWN'
                                      ? 'trending_down'
                                      : 'trending_flat'
                            }}
                        </mat-icon>
                    </td>
                </ng-container> -->

                <!-- Status -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef
                        class="align-middle text-muted-foreground bg-muted/30 h-12 px-4 text-left text-xs font-semibold uppercase tracking-wider">
                        STATUS
                    </th>
                    <td mat-cell *matCellDef="let row" class="align-middle p-4">
                        <span class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium"
                            [ngClass]="{
                                'border-green-200 bg-green-100 text-green-700':
                                    row.status === 'ACTIVE',
                                'border-yellow-200 bg-yellow-100 text-yellow-700':
                                    row.status === 'PENDING',
                                'border-red-200 bg-red-100 text-red-700':
                                    row.status === 'BLOCKED',
                            }">
                            <span class="mr-1.5 h-1.5 w-1.5 rounded-full" [ngClass]="{
                                    'bg-green-500': row.status === 'ACTIVE',
                                    'bg-yellow-500': row.status === 'PENDING',
                                    'bg-red-500': row.status === 'BLOCKED',
                                }">
                            </span>
                            {{
                            row.status === 'ACTIVE'
                            ? 'Ativo'
                            : row.status === 'PENDING'
                            ? 'Pendente'
                            : 'Inativo'
                            }}
                        </span>
                    </td>
                </ng-container>

                <!-- Action -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="text-gray-600 hover:text-black">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="newCategory(row)">
                                <mat-icon>visibility</mat-icon>
                                <span>Ver Detalhes</span>
                            </button>
                            <button mat-menu-item (click)="newCategory(row)"
                                *ngIf="!permissionService.can('edit_category')">
                                <mat-icon>edit</mat-icon>
                                <span>Editar</span>
                            </button>
                            <button mat-menu-item *ngIf="row.status === 'ACTIVE'" (click)="blockCategory(row)"
                                class="text-red-600">
                                <mat-icon class="text-red-600">pause_circle</mat-icon>
                                <span>Inativar</span>
                            </button>
                            <button mat-menu-item *ngIf="row.status === 'BLOCKED'" (click)="reactivateCategory(row)"
                                class="text-green-600">
                                <mat-icon class="text-green-600">check_circle</mat-icon>
                                <span>Reativar</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"
                    cdkDrag
                    class="hover:bg-slate-50 dark:hover:bg-hover cursor-move">
                    <div *cdkDragPreview class="bg-white dark:bg-gray-800 shadow-xl border border-gray-200 dark:border-gray-700 rounded-lg p-4 flex items-center gap-4 text-gray-900 dark:text-white">
                        <mat-icon class="text-gray-400">drag_indicator</mat-icon>
                        <span class="font-medium">{{row.name || 'Categoria'}}</span>
                    </div>
                </tr>
            </table>

            <!-- <mat-paginator class="w-full" [length]="totalAmount" [pageSize]="searchParams.size"
                [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons (page)="handlePageEvent($event)">
            </mat-paginator> -->
        </div>
    </fuse-card>
</main>